import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import { createAllEventVideosRequestedAction } from '../../../actions/eventVideosActions';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../../componentBase';
import { AppSelectField } from '../../form/appSelectField';
import { AppTextField } from '../../form/appTextField';
import { required } from '../../form/formValidations';

interface UnknownParticipantsFormOwnProps {
  eventId: string;
}

interface UnknownParticipantsFormStateProps extends BaseStateProps {
  eventVideos: EventVideoViewModel[];
}

interface UnknownParticipantFormFieldsFormDispatchProps extends BaseDispatchProps {
  loadAllEventVideos: (c: UnknownParticipantFormFields) => void;
}

class UnknownParticipantFormFields extends ComponentBase<
  UnknownParticipantsFormOwnProps,
  UnknownParticipantsFormStateProps,
  UnknownParticipantFormFieldsFormDispatchProps
> {
  protected dataLoaded(props: any) {
    return props.eventVideos;
  }

  protected loadData(props: any) {
    return props.loadAllEventVideos(this);
  }

  protected loggedInRender() {
    return (
      <>
        <AppTextField name="audioStartTime" label="Audio start timestamp" validate={[required]} />
        <AppTextField name="audioEndTime" label="Audio end timestamp" validate={[required]} />
        <AppTextField name="videoStartTime" label="Video start timestamp" />
        <AppTextField name="videoEndTime" label="Video end timestamp" />
        <AppSelectField
          name="eventVideoId"
          options={this.getEventVideoOptions()}
          label="Event Video"
          validate={[required]}
        />
      </>
    );
  }

  private getEventVideoOptions() {
    return this.props.eventVideos.map(eventVideo => ({ value: eventVideo.id, label: eventVideo.name }));
  }
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: UnknownParticipantsFormOwnProps,
): UnknownParticipantsFormStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);

  return {
    ...baseMapStateToProps(state),
    eventVideos: getAllWithIds(state.entities.eventVideos, event.eventVideos),
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: UnknownParticipantsFormOwnProps,
): UnknownParticipantFormFieldsFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadAllEventVideos: (c: UnknownParticipantFormFields) =>
      dispatch(createAllEventVideosRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnknownParticipantFormFields);
